import { TeamMember } from '../types';
import placeholderAvatar from '../assets/images/placeholder-avatar.svg';

export const teamMembers: TeamMember[] = [
  {
    id: 'polyak-donat',
    nameKey: 'team.polyakDonat.name',
    roleKey: 'team.polyakDonat.role',
    bioKey: 'team.polyakDonat.bio',
    imageUrl: placeholderAvatar,
    email: 'rehab@chipet.app',
    phone: '+36 20 944 0504',
  },
];
